<template>
  <div v-if="facet.name" class="card border-0" :id="'facet-' + facet.id">
    <button
      class="filter-title d-flex justify-content-between align-items-center text-left w-100 bg-white"
      :class="{ collapsed: !isFacetActive }"
      type="button"
      @click="toggleFacet"
    >
      {{ facetName }}
    </button>

    <div
      class="collapse"
      :class="{ show: isFacetActive }"
      :id="'collapse-facet-' + facet.id"
      @click="$event.stopPropagation()"
    >
      <div class="pb-3 d-flex flex-column filter-facet-wrapper">
        <item-filter-price
          v-if="facet.type === 'price'"
          :category-id="categoryId"
        ></item-filter-price>

        <div
          v-else
          v-for="value in facet.values"
          :key="value.id"
          class="form-check-wrapper"
        >
          <div class="form-check mb-0 pl-0 cursor-pointer">
            <input
              :id="'option-' + value.id"
              class="form-check-input d-none"
              type="checkbox"
              :checked="isSelected(value.id)"
              @change="updateFacet(value)"
              :disabled="isLoading || value.count <= 0"
              :aria-labelledby="'label-' + value.id"
            />
            <label
              :for="'option-' + value.id"
              :id="'label-' + value.id"
              class="form-check-label d-flex align-items-center cursor-pointer w-100 position-relative"
              :class="{ 'p-3': facet.id === 28 }"
            >
              <img
                v-if="facet.id === 28"
                v-lazyload-img
                :data-src="`${publicPath}/images/colors/${value.id}.webp`"
                :alt="value.name"
                :title="value.name"
                width="48"
                height="48"
                loading="lazy"
              />
              <span v-else v-html="getFormattedName(value.name)"></span>
            </label>
          </div>

          <hr
            v-if="[201, 205, 212, 220, 224].includes(value.id)"
            class="mt-3 mb-2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "./ItemFilterPrice.vue";

export default {
  name: "item-filter",

  components: {
    "item-filter-price": ItemFilterPrice,
  },

  props: {
    facet: {
      type: Object,
      required: true,
    },
    categoryId: {
      type: Number,
      required: false,
    },
    publicPath: {
      type: String,
      required: true,
    },
    activeFacets: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState({
      selectedFacets: (state) => state.itemList.selectedFacets,
      isLoading: (state) => state.itemList.isLoading,
    }),

    facetName() {
      return this.facet.translationKey && this.facet.translationKey.length > 0
        ? this.$translate("Ceres::Template." + this.facet.translationKey)
        : this.facet.name;
    },

    isFacetActive() {
      return this.activeFacets.includes(this.facet.id);
    },
  },

  methods: {
    toggleFacet() {
      this.$emit("toggle-facet", this.facet.id);
    },
    updateFacet(facetValue) {
      this.$store.dispatch("selectFacet", { facetValue });
    },
    isSelected(facetValueId) {
      return this.selectedFacets.some(
        (selectedFacet) => selectedFacet.id === facetValueId
      );
    },
    getFormattedName(name) {
      const trimmedName =
        this.facet.id === 29 && name.includes("/")
          ? name.split("/")[1].trim()
          : name;
      if (trimmedName) {
        return trimmedName.replace(/(\d+(\s?x\s?\d+)?\s?cm)/g, "<b>$1</b>");
      }
      return trimmedName;
    },
  },
};
</script>
